// ============================================================
// MAPEO SINTÉTICO OSM → GRUPO (vista realista santa-coloma)
// AUTO-GENERADO por tools/gen-osm-mapping.py — no editar a mano.
// Re-ejecutar para regenerar.
//
// Cada entry asigna un nodo OSM físico (de santaColomaStaticSignals)
// al cabinet más cercano y, dentro de ese cabinet, al grupo más
// cercano. `distanceM` es la distancia OSM↔cabinet (QA, no usada en
// runtime). `osmDirection` viene del tag OSM `traffic_signals:direction`
// cuando existe; F4 lo usa para resolver el bearing del cabezal.
//
// Cuando ARS93 entregue la topología real (o el polygon editor
// permita ajustar este mapeo), reemplazar este archivo o componerlo
// con `osm-group-mapping.overrides.ts` en runtime.
// ============================================================

export interface OsmGroupAssignment {
  osmId: number;
  cabinetId: number;
  groupId: number;
  distanceM: number;
  osmDirection: 'forward' | 'backward' | null;
}

export const osmGroupMapping: OsmGroupAssignment[] = [
  { osmId: 359691769, cabinetId: 15, groupId: 1, distanceM: 33.57, osmDirection: 'forward' },
  { osmId: 3040841188, cabinetId: 15, groupId: 1, distanceM: 21.02, osmDirection: 'forward' },
  { osmId: 365123817, cabinetId: 29, groupId: 4, distanceM: 13.0, osmDirection: null },
  { osmId: 370608856, cabinetId: 23, groupId: 2, distanceM: 19.08, osmDirection: null },
  { osmId: 370608901, cabinetId: 25, groupId: 3, distanceM: 3.61, osmDirection: null },
  { osmId: 2857821368, cabinetId: 25, groupId: 3, distanceM: 17.89, osmDirection: null },
  { osmId: 370608910, cabinetId: 29, groupId: 1, distanceM: 9.09, osmDirection: null },
  { osmId: 370608915, cabinetId: 31, groupId: 4, distanceM: 16.79, osmDirection: null },
  { osmId: 370608917, cabinetId: 31, groupId: 4, distanceM: 43.17, osmDirection: null },
  { osmId: 9350744816, cabinetId: 31, groupId: 4, distanceM: 38.25, osmDirection: null },
  { osmId: 428026393, cabinetId: 205, groupId: 4, distanceM: 69.8, osmDirection: 'forward' },
  { osmId: 600061544, cabinetId: 4, groupId: 2, distanceM: 35.81, osmDirection: 'forward' },
  { osmId: 10195726511, cabinetId: 4, groupId: 2, distanceM: 34.01, osmDirection: 'forward' },
  { osmId: 611299265, cabinetId: 15, groupId: 10, distanceM: 53.96, osmDirection: 'forward' },
  { osmId: 3040841186, cabinetId: 15, groupId: 10, distanceM: 55.83, osmDirection: 'forward' },
  { osmId: 1341444419, cabinetId: 21, groupId: 3, distanceM: 36.38, osmDirection: null },
  { osmId: 5301259065, cabinetId: 21, groupId: 3, distanceM: 17.49, osmDirection: 'backward' },
  { osmId: 8545709835, cabinetId: 21, groupId: 3, distanceM: 40.47, osmDirection: 'forward' },
  { osmId: 1371264422, cabinetId: 74, groupId: 1, distanceM: 43.76, osmDirection: 'forward' },
  { osmId: 11390006562, cabinetId: 74, groupId: 1, distanceM: 62.21, osmDirection: 'forward' },
  { osmId: 1489990576, cabinetId: 205, groupId: 3, distanceM: 56.03, osmDirection: 'forward' },
  { osmId: 2857808096, cabinetId: 22, groupId: 4, distanceM: 10.3, osmDirection: 'forward' },
  { osmId: 8545709833, cabinetId: 22, groupId: 4, distanceM: 39.65, osmDirection: 'backward' },
  { osmId: 8545709834, cabinetId: 22, groupId: 4, distanceM: 20.86, osmDirection: null },
  { osmId: 4569356442, cabinetId: 54, groupId: 2, distanceM: 21.97, osmDirection: 'forward' },
  { osmId: 4569356445, cabinetId: 54, groupId: 2, distanceM: 36.59, osmDirection: 'forward' },
  { osmId: 7417379585, cabinetId: 54, groupId: 2, distanceM: 57.91, osmDirection: 'forward' },
  { osmId: 7417379586, cabinetId: 54, groupId: 2, distanceM: 55.57, osmDirection: 'forward' },
  { osmId: 7417379587, cabinetId: 54, groupId: 2, distanceM: 77.87, osmDirection: 'forward' },
  { osmId: 11285774443, cabinetId: 54, groupId: 2, distanceM: 71.52, osmDirection: null },
  { osmId: 5124632803, cabinetId: 23, groupId: 3, distanceM: 4.52, osmDirection: null },
  { osmId: 5675594311, cabinetId: 204, groupId: 4, distanceM: 9.19, osmDirection: 'forward' },
  { osmId: 5675596325, cabinetId: 205, groupId: 15, distanceM: 77.18, osmDirection: 'backward' },
  { osmId: 5675596326, cabinetId: 204, groupId: 10, distanceM: 64.56, osmDirection: 'backward' },
  { osmId: 5675596328, cabinetId: 204, groupId: 11, distanceM: 87.58, osmDirection: 'forward' },
  { osmId: 6119950631, cabinetId: 86, groupId: 4, distanceM: 14.35, osmDirection: 'forward' },
  { osmId: 7417371878, cabinetId: 15, groupId: 4, distanceM: 22.88, osmDirection: 'forward' },
  { osmId: 7417371879, cabinetId: 15, groupId: 3, distanceM: 26.79, osmDirection: 'forward' },
  { osmId: 7417371880, cabinetId: 15, groupId: 11, distanceM: 68.12, osmDirection: 'forward' },
  { osmId: 7830020111, cabinetId: 15, groupId: 11, distanceM: 95.37, osmDirection: null },
  { osmId: 7417371883, cabinetId: 54, groupId: 4, distanceM: 45.64, osmDirection: 'forward' },
  { osmId: 7417371884, cabinetId: 54, groupId: 3, distanceM: 20.13, osmDirection: 'forward' },
  { osmId: 8357867922, cabinetId: 0, groupId: 2, distanceM: 20.08, osmDirection: 'forward' },
  { osmId: 8357867938, cabinetId: 0, groupId: 4, distanceM: 45.81, osmDirection: 'backward' },
  { osmId: 10189568679, cabinetId: 0, groupId: 4, distanceM: 39.91, osmDirection: 'forward' },
  { osmId: 8361108743, cabinetId: 2, groupId: 4, distanceM: 16.05, osmDirection: 'forward' },
  { osmId: 8514437732, cabinetId: 82, groupId: 3, distanceM: 20.48, osmDirection: 'backward' },
  { osmId: 8514438013, cabinetId: 2, groupId: 1, distanceM: 28.32, osmDirection: 'backward' },
  { osmId: 8667136188, cabinetId: 82, groupId: 2, distanceM: 16.68, osmDirection: 'forward' },
  { osmId: 9349008541, cabinetId: 31, groupId: 2, distanceM: 24.3, osmDirection: null },
  { osmId: 9349008542, cabinetId: 32, groupId: 1, distanceM: 43.01, osmDirection: null },
  { osmId: 9349008544, cabinetId: 32, groupId: 3, distanceM: 45.89, osmDirection: null },
  { osmId: 9349008546, cabinetId: 33, groupId: 4, distanceM: 30.16, osmDirection: 'backward' },
  { osmId: 9349008547, cabinetId: 33, groupId: 3, distanceM: 18.69, osmDirection: null },
  { osmId: 9349008549, cabinetId: 33, groupId: 3, distanceM: 20.92, osmDirection: 'backward' },
  { osmId: 9349008548, cabinetId: 33, groupId: 2, distanceM: 21.35, osmDirection: 'forward' },
  { osmId: 9349008555, cabinetId: 34, groupId: 1, distanceM: 33.61, osmDirection: null },
  { osmId: 9349008556, cabinetId: 34, groupId: 2, distanceM: 13.84, osmDirection: null },
  { osmId: 9349008557, cabinetId: 34, groupId: 2, distanceM: 23.72, osmDirection: null },
  { osmId: 9350744815, cabinetId: 31, groupId: 1, distanceM: 16.16, osmDirection: null },
  { osmId: 9350815635, cabinetId: 13, groupId: 3, distanceM: 13.47, osmDirection: null },
  { osmId: 9350815636, cabinetId: 13, groupId: 4, distanceM: 9.04, osmDirection: null },
  { osmId: 9350815637, cabinetId: 52, groupId: 3, distanceM: 74.9, osmDirection: null },
  { osmId: 9350815638, cabinetId: 51, groupId: 4, distanceM: 15.97, osmDirection: null },
  { osmId: 9350815641, cabinetId: 51, groupId: 8, distanceM: 81.54, osmDirection: null },
  { osmId: 9350815642, cabinetId: 50, groupId: 2, distanceM: 10.21, osmDirection: null },
  { osmId: 9350815645, cabinetId: 0, groupId: 1, distanceM: 17.58, osmDirection: 'forward' },
  { osmId: 9350815647, cabinetId: 72, groupId: 4, distanceM: 59.6, osmDirection: null },
  { osmId: 9350815663, cabinetId: 70, groupId: 3, distanceM: 11.95, osmDirection: null },
  { osmId: 9350840949, cabinetId: 53, groupId: 2, distanceM: 24.21, osmDirection: 'backward' },
  { osmId: 9350840952, cabinetId: 52, groupId: 4, distanceM: 8.39, osmDirection: null },
  { osmId: 10195655150, cabinetId: 1, groupId: 2, distanceM: 26.22, osmDirection: 'forward' },
  { osmId: 10195655152, cabinetId: 1, groupId: 3, distanceM: 13.01, osmDirection: 'forward' },
  { osmId: 10195655154, cabinetId: 1, groupId: 3, distanceM: 30.91, osmDirection: 'forward' },
  { osmId: 10195655153, cabinetId: 1, groupId: 4, distanceM: 10.98, osmDirection: 'forward' },
  { osmId: 10195655165, cabinetId: 2, groupId: 3, distanceM: 12.67, osmDirection: 'forward' },
  { osmId: 10195726505, cabinetId: 3, groupId: 10, distanceM: 65.47, osmDirection: 'forward' },
  { osmId: 10195753817, cabinetId: 3, groupId: 4, distanceM: 23.44, osmDirection: 'forward' },
  { osmId: 10565331756, cabinetId: 74, groupId: 2, distanceM: 14.52, osmDirection: 'forward' },
  { osmId: 11293237602, cabinetId: 53, groupId: 4, distanceM: 16.95, osmDirection: 'forward' },
  { osmId: 11293237603, cabinetId: 53, groupId: 3, distanceM: 10.17, osmDirection: 'forward' },
  { osmId: 11390006561, cabinetId: 74, groupId: 4, distanceM: 56.99, osmDirection: 'forward' }
];

export const osmGroupByOsmId: Record<number, OsmGroupAssignment> = {
  359691769: osmGroupMapping[0],
  3040841188: osmGroupMapping[1],
  365123817: osmGroupMapping[2],
  370608856: osmGroupMapping[3],
  370608901: osmGroupMapping[4],
  2857821368: osmGroupMapping[5],
  370608910: osmGroupMapping[6],
  370608915: osmGroupMapping[7],
  370608917: osmGroupMapping[8],
  9350744816: osmGroupMapping[9],
  428026393: osmGroupMapping[10],
  600061544: osmGroupMapping[11],
  10195726511: osmGroupMapping[12],
  611299265: osmGroupMapping[13],
  3040841186: osmGroupMapping[14],
  1341444419: osmGroupMapping[15],
  5301259065: osmGroupMapping[16],
  8545709835: osmGroupMapping[17],
  1371264422: osmGroupMapping[18],
  11390006562: osmGroupMapping[19],
  1489990576: osmGroupMapping[20],
  2857808096: osmGroupMapping[21],
  8545709833: osmGroupMapping[22],
  8545709834: osmGroupMapping[23],
  4569356442: osmGroupMapping[24],
  4569356445: osmGroupMapping[25],
  7417379585: osmGroupMapping[26],
  7417379586: osmGroupMapping[27],
  7417379587: osmGroupMapping[28],
  11285774443: osmGroupMapping[29],
  5124632803: osmGroupMapping[30],
  5675594311: osmGroupMapping[31],
  5675596325: osmGroupMapping[32],
  5675596326: osmGroupMapping[33],
  5675596328: osmGroupMapping[34],
  6119950631: osmGroupMapping[35],
  7417371878: osmGroupMapping[36],
  7417371879: osmGroupMapping[37],
  7417371880: osmGroupMapping[38],
  7830020111: osmGroupMapping[39],
  7417371883: osmGroupMapping[40],
  7417371884: osmGroupMapping[41],
  8357867922: osmGroupMapping[42],
  8357867938: osmGroupMapping[43],
  10189568679: osmGroupMapping[44],
  8361108743: osmGroupMapping[45],
  8514437732: osmGroupMapping[46],
  8514438013: osmGroupMapping[47],
  8667136188: osmGroupMapping[48],
  9349008541: osmGroupMapping[49],
  9349008542: osmGroupMapping[50],
  9349008544: osmGroupMapping[51],
  9349008546: osmGroupMapping[52],
  9349008547: osmGroupMapping[53],
  9349008549: osmGroupMapping[54],
  9349008548: osmGroupMapping[55],
  9349008555: osmGroupMapping[56],
  9349008556: osmGroupMapping[57],
  9349008557: osmGroupMapping[58],
  9350744815: osmGroupMapping[59],
  9350815635: osmGroupMapping[60],
  9350815636: osmGroupMapping[61],
  9350815637: osmGroupMapping[62],
  9350815638: osmGroupMapping[63],
  9350815641: osmGroupMapping[64],
  9350815642: osmGroupMapping[65],
  9350815645: osmGroupMapping[66],
  9350815647: osmGroupMapping[67],
  9350815663: osmGroupMapping[68],
  9350840949: osmGroupMapping[69],
  9350840952: osmGroupMapping[70],
  10195655150: osmGroupMapping[71],
  10195655152: osmGroupMapping[72],
  10195655154: osmGroupMapping[73],
  10195655153: osmGroupMapping[74],
  10195655165: osmGroupMapping[75],
  10195726505: osmGroupMapping[76],
  10195753817: osmGroupMapping[77],
  10565331756: osmGroupMapping[78],
  11293237602: osmGroupMapping[79],
  11293237603: osmGroupMapping[80],
  11390006561: osmGroupMapping[81],
};

export const osmGroupByCabinetId: Record<number, OsmGroupAssignment[]> = {
  0: osmGroupMapping.filter(m => [8357867922, 8357867938, 10189568679, 9350815645].includes(m.osmId)),
  1: osmGroupMapping.filter(m => [10195655150, 10195655152, 10195655154, 10195655153].includes(m.osmId)),
  2: osmGroupMapping.filter(m => [8361108743, 8514438013, 10195655165].includes(m.osmId)),
  3: osmGroupMapping.filter(m => [10195726505, 10195753817].includes(m.osmId)),
  4: osmGroupMapping.filter(m => [600061544, 10195726511].includes(m.osmId)),
  13: osmGroupMapping.filter(m => [9350815635, 9350815636].includes(m.osmId)),
  15: osmGroupMapping.filter(m => [359691769, 3040841188, 611299265, 3040841186, 7417371878, 7417371879, 7417371880, 7830020111].includes(m.osmId)),
  21: osmGroupMapping.filter(m => [1341444419, 5301259065, 8545709835].includes(m.osmId)),
  22: osmGroupMapping.filter(m => [2857808096, 8545709833, 8545709834].includes(m.osmId)),
  23: osmGroupMapping.filter(m => [370608856, 5124632803].includes(m.osmId)),
  25: osmGroupMapping.filter(m => [370608901, 2857821368].includes(m.osmId)),
  29: osmGroupMapping.filter(m => [365123817, 370608910].includes(m.osmId)),
  31: osmGroupMapping.filter(m => [370608915, 370608917, 9350744816, 9349008541, 9350744815].includes(m.osmId)),
  32: osmGroupMapping.filter(m => [9349008542, 9349008544].includes(m.osmId)),
  33: osmGroupMapping.filter(m => [9349008546, 9349008547, 9349008549, 9349008548].includes(m.osmId)),
  34: osmGroupMapping.filter(m => [9349008555, 9349008556, 9349008557].includes(m.osmId)),
  50: osmGroupMapping.filter(m => [9350815642].includes(m.osmId)),
  51: osmGroupMapping.filter(m => [9350815638, 9350815641].includes(m.osmId)),
  52: osmGroupMapping.filter(m => [9350815637, 9350840952].includes(m.osmId)),
  53: osmGroupMapping.filter(m => [9350840949, 11293237602, 11293237603].includes(m.osmId)),
  54: osmGroupMapping.filter(m => [4569356442, 4569356445, 7417379585, 7417379586, 7417379587, 11285774443, 7417371883, 7417371884].includes(m.osmId)),
  70: osmGroupMapping.filter(m => [9350815663].includes(m.osmId)),
  72: osmGroupMapping.filter(m => [9350815647].includes(m.osmId)),
  74: osmGroupMapping.filter(m => [1371264422, 11390006562, 10565331756, 11390006561].includes(m.osmId)),
  82: osmGroupMapping.filter(m => [8514437732, 8667136188].includes(m.osmId)),
  86: osmGroupMapping.filter(m => [6119950631].includes(m.osmId)),
  204: osmGroupMapping.filter(m => [5675594311, 5675596326, 5675596328].includes(m.osmId)),
  205: osmGroupMapping.filter(m => [428026393, 1489990576, 5675596325].includes(m.osmId)),
};
